import * as actionTypes from '../actions/actionTypes';

const intiData = {
  data: {},
  accordionStatus: {
    basicDetails: {
      status: "incomplete"
    },
    eChannelReporting: {
      status: "incomplete"
    }
  },
  eChannelReportingDetails: {
    reportToEChannel: "",
    eChannelReportingList: [],
    selectedEChannel: {}
  }
};

export default function currentProductCashFlowForecastingReducer(state = intiData, action) {
  switch (action.type) {
    case actionTypes.SET_PRODUCT_CASHFLOWFORECASTING: {
      return Object.assign({}, state, action.data)
    }

    case actionTypes.SET_CASHFLOWFORECASTING_ACTIVE_TAB_INDEX: {
      let newState = { ...state };
      newState.activeTabIndex = action.index;
      return newState;
    }

    case actionTypes.RESET_CASHFLOWFORECASTING_ACTIVE_TAB_INDEX: {
      let newState = { ...state };
      newState.activeTabIndex = -1;
      return newState;
    }

    case actionTypes.RESET_CASHFLOWFORECASTING_PRODUCT: {
      return intiData;
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/currentProductCashFlowForecastingReducer.js